/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_My_ServicesInputs */

const en_nav_my_services = /** @type {(inputs: Nav_My_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Services`)
};

const fr_nav_my_services = /** @type {(inputs: Nav_My_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes services`)
};

/**
* | output |
* | --- |
* | "My Services" |
*
* @param {Nav_My_ServicesInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_my_services = /** @type {((inputs?: Nav_My_ServicesInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_My_ServicesInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_my_services(inputs)
	return fr_nav_my_services(inputs)
});